export const fontStyles = {
  regular: `
  font-family: var(--font-Pretendard-Regular);
  `,
  medium: `
  font-family: var(--font-Pretendard-Medium);
  `,
  semiBold: `
    font-family: var(--font-Pretendard-SemiBold);
  `,
  Bold: `
    font-family: var(--font-Pretendard-Bold);
  `,
};
